import React from "react";
import { Button } from "primereact/button";
import plusIcon from "../../assests/images/plusIcon.png";
import filterIcon from "../../assests/images/filter.png";

const CommonButton = ({
  label,
  icon,
  onClick,
  color = "",
  variant = "",
  size = "p-button-md",
  className = "btn-padding",
  disabled = false,
  loading = false,
  type = "button",
  id,
  inputStyle,
  buttonRef,
}) => {
  const iconClass = icon ? "with-icon mt-1 padding-align " : "no-icon";
  return (
    <>
      <Button
        label={label}
        className={`${className}  btn-${variant} ${inputStyle}  ${iconClass} `}
        onClick={onClick}
        icon={
          icon === true ? (
            <img src={plusIcon} alt="plus" className="align-items-center" />
          ) : icon === false ? (
            <img src={filterIcon} alt="filter" className="align-items-center" style={{}} />
          ) : null
        }
        disabled={disabled}
        loading={loading}
        id={id}
        ref={buttonRef}
      />
    </>
  );
};
export default CommonButton;
